<template>
  <div class="list-container">
    <router-link
      v-for="question in questions"
      :key="`question-${question.flashcardId}`"
      :to="question.route"
      class="list-row-container"
      data-test="question-row"
    >
      <div
        :class="{correct: question.correct}"
        class="icon-wrapper"
      >
        <icon
          :name="iconName(question)"
          variant="white"
          class="icon"
        />
      </div>
      <div
        class="text-sm font-medium text-primary-900 text-truncate-1-line"
        v-html="question.text"
      />
    </router-link>
  </div>
</template>

<script>
import Icon from '@components/singletons/icon';

export default {
  name: 'QuestionList',
  components: { Icon },
  props: {
    questions: {
      type: Array,
      default: () => [],
      validator(questions) {
        return questions.every(q =>
          q.hasOwnProperty('flashcardId') &&
          q.hasOwnProperty('route') &&
          q.hasOwnProperty('correct') &&
          q.hasOwnProperty('text'),
        );
      },
    },
  },
  methods: {
    iconName(question) {
      return question.correct ? 'check' : 'cross-thin';
    },
  },
};
</script>

<style lang='scss' scoped>
  .list-container {
    .icon-wrapper {
      background-color: var(--utility-error-500);
      height: rem-calc(20);
      min-width: rem-calc(20);
      border-radius: var(--radius-full);
      display: flex;
      align-items: center;
      justify-content: center;

      &.correct {
        background-color: var(--utility-success-500);

        .icon {
          height: rem-calc(14);
          width: rem-calc(14);
        }
      }

      .icon {
        height: rem-calc(10);
        width: rem-calc(10);
      }
    }
  }
</style>
